import React from 'react';
const LoadingPaperPlane = () => {
    return (
        <div className="text-center">
            <img src="/assets/images/loading-paper-plane.gif" alt="Loading..." />
        </div>
    );
};
export default LoadingPaperPlane;